import CloseIcon from "@mui/icons-material/Close";
import {
  Card,
  CardContent,
  CardHeader,
  Dialog,
  IconButton,
  Table,
  TableCell,
  TableRow,
  Box,
  CircularProgress,
  Checkbox,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useAnnouncements } from "./AnnoucementsContext";

const AnnouncementEvents = () => {
  const [open, setOpen] = useState(false);
  const {
    announcement,
    selectedEventBtn,
    setSelectedEventBtn,
    setAnnouncement,
    events,
    setEvents,
  } = useAnnouncements();

  useEffect(() => {
    setOpen(selectedEventBtn);
  }, [selectedEventBtn]);

  const onClose = (e, reason) => {
    setSelectedEventBtn(false);
  };

  const isEventIdExist = (eventId) => {
    return announcement.eventIds.indexOf(eventId.toString().trim()) > -1
      ? true
      : false;
  };

  const handleEventId = (e) => {
    const checked = e.target.checked;
    const eventId = e.target.value;
    if (checked) {
      announcement.eventIds.push(eventId);
      setAnnouncement((announcement) => ({
        ...announcement,
        eventIds: announcement.eventIds,
      }));
    } else {
      const eventIdIdx = announcement.eventIds.indexOf(eventId);
      if (eventIdIdx !== -1) {
        setAnnouncement((announcement) => ({
          ...announcement,
          eventIds: announcement.eventIds.filter((ele) => ele !== eventId),
        }));
      }
    }
  };

  return (
    <Dialog
      fullWidth
      maxWidth
      onClose={onClose}
      open={open}
      sx={{ overflow: "auto" }}
    >
      <IconButton
        aria-label="close"
        onClick={onClose}
        sx={{
          position: "absolute",
          right: 10,
          top: 8,
        }}
      >
        <CloseIcon />
      </IconButton>
      <Card sx={{ borderRadius: 3, overflow: "auto" }}>
        <CardHeader
          title={<font className="layer-title"> Announcement Events </font>}
          align="center"
          className={"styledtablerow"}
        />

        <CardContent sx={{ paddingTop: 1, paddingLeft: 0, paddingRight: 0 }}>
          {events && announcement && (
            <Table size="small" sx={{ overflow: "auto" }}>
              <TableRow className="report-header">
                <TableCell></TableCell>
                <TableCell> Event Id </TableCell>
                <TableCell> Event ExternalId </TableCell>
                <TableCell> Location </TableCell>
                <TableCell> Description </TableCell>
              </TableRow>

              {events.map((eachEvent, idx) => {
                return (
                  <TableRow
                    key={eachEvent.externalId}
                    className={idx % 2 === 0 ? "styledtablerow" : ""}
                  >
                    <TableCell>
                      <Checkbox
                        id={eachEvent.externalId}
                        key={eachEvent.externalId}
                        value={eachEvent.id}
                        checked={isEventIdExist(eachEvent.id)}
                        onChange={handleEventId}
                      ></Checkbox>
                    </TableCell>
                    <TableCell> {eachEvent.id} </TableCell>
                    <TableCell> {eachEvent.externalId} </TableCell>
                    <TableCell> {eachEvent.location} </TableCell>
                    <TableCell> {eachEvent.description} </TableCell>
                  </TableRow>
                );
              })}
            </Table>
          )}
          {!events && (
            <Box
              sx={{
                display: "flex",
                alignContent: "center",
                alignItems: "center",
                padding: 10,
                width: "100%",
              }}
            >
              <CircularProgress sx={{ margin: "auto" }} />
            </Box>
          )}
        </CardContent>
      </Card>
    </Dialog>
  );
};

export default AnnouncementEvents;
